/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ua */
/* unused harmony export locationOriginRegex */
/* unused harmony export isIE */
/* unused harmony export isEdge */
/* unused harmony export isOpera */
/* unused harmony export isChrome */
/* unused harmony export isIOS */
/* unused harmony export isAndroid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return truthy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return falsy; });
/* unused harmony export existy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isDefined; });
/* unused harmony export isRc */
/* unused harmony export isInteger */
/* unused harmony export isString */
/* unused harmony export isNumber */
/* unused harmony export isBoolean */
/* unused harmony export isObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isFunction; });
/* unused harmony export isRegExp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return not; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isNotDefined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return parseInt10; });
/* unused harmony export parseStrIntToInt */
/* unused harmony export removeElementInArray */
/* unused harmony export allOf */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return anyOf; });
/* unused harmony export getDefined */
/* unused harmony export notSingleEle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return each; });
/* unused harmony export getFileExtension */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getFirstObjectHasProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getObjectHasProperty; });
/* unused harmony export overlappedConditionSortByProperty */
/* unused harmony export getPositionFromTranslateStr */
/* unused harmony export isIndexInLoop */
/* unused harmony export getLoopedLastIndex */
/* unused harmony export getReverseLoopedFirstIndex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getResolution; });
/* unused harmony export isPhoneResolution */
/* unused harmony export isTabletResolution */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isMobileResolution; });
/* unused harmony export numberWithCommas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getUriParams; });
/* unused harmony export getUriCombinedParams */
/* unused harmony export getHashParams */
/* unused harmony export getHashCombinedParams */
/* unused harmony export getObjForPagination */
/* unused harmony export getDivideIntStrByThousandUnit */
/* unused harmony export getMarketPriceStr */
/* unused harmony export getEmphasizedStrByQuery */
/* unused harmony export getSeparatedDateStr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return namespace; });
/* unused harmony export template */
/* unused harmony export getUrlAddCategoryIdByArticle */
/* unused harmony export getChangedStats */
/* unused harmony export getPlusElixirPointByLevel */
/* unused harmony export isLevelCanConsumeElixirStat */
/* unused harmony export isLevelGetElixirPoint */
/* unused harmony export getStatMaxByLevel */
/* unused harmony export isWarrior */
/* unused harmony export getClassName */
/* unused harmony export removeEquipInEquips */
/* unused harmony export isPetNecklace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_model__ = __webpack_require__(1);
/*
 * common utils
 */



var ua = window.navigator.userAgent;

var locationOriginRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})/;

var isIE = function () {
  return (/msie/i.test(ua) || /trident/i.test(ua)
  );
}();

var isEdge = function isEdge(userAgent) {
  return (/Gecko/i.test(userAgent) && /Edge/i.test(userAgent)
  );
};

var isOpera = function isOpera(userAgent) {
  return (/Opera/i.test(userAgent) || /OPR\//i.test(userAgent)
  );
};

var isChrome = function isChrome(userAgent) {
  return !isEdge(userAgent) && !isOpera(userAgent) && /Chrome/i.test(userAgent);
};

var isIOS = function isIOS(userAgent) {
  return (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  );
};

var isAndroid = function isAndroid(userAgent) {
  return (/android/i.test(userAgent)
  );
};

var truthy = function truthy(object) {
  return !!object;
};

var falsy = function falsy(object) {
  return !!!object;
};

var existy = function existy(obj) {
  return obj != null;
};

var isDefined = function isDefined(obj) {
  var flag = true;
  if (obj === null || typeof obj === 'undefined') return false;
  return flag;
};

var isRc = function () {
  return isDefined(/^rc-/.exec(location.hostname));
}();

var isInteger = function isInteger(obj) {
  if (!isDefined(obj) || obj.constructor !== Number) return false;

  // https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger
  return isFinite(obj) && Math.floor(obj) === obj;
};

var isString = function isString(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === String;
};

var isNumber = function isNumber(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Number;
};

var isBoolean = function isBoolean(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Boolean;
};

var isObject = function isObject(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Object;
};

var isFunction = function isFunction(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === Function;
};

var isRegExp = function isRegExp(obj) {
  if (!isDefined(obj)) return false;
  return obj.constructor === RegExp;
};

var not = function not(func) {
  if (!isFunction(func)) throw new TypeError('func parameter type of not() must be Function.');

  return function (object) {
    return !func(object);
  };
};

var isNotDefined = not(isDefined);

var parseInt10 = function parseInt10(number) {
  return parseInt(number, 10);
};

var parseStrIntToInt = function parseStrIntToInt(strIntOrInt) {
  var val = strIntOrInt;

  if (!isDefined(val)) return 0;
  if (typeof val === 'number') return val;

  return parseInt10(val.split(',').join(''));
};

var removeElementInArray = function removeElementInArray(arr, target) {
  if (!Array.isArray(arr)) throw new TypeError('arr parameter type of removeElementInArray() must be Array.');

  var clonedArr = arr.slice(0),
      index = clonedArr.indexOf(target);

  if (index >= 0) clonedArr.splice(index, 1);

  return clonedArr;
};

var allOf = function allOf() /*args*/{
  var args = Array.prototype.slice.call(arguments);

  return args.every(function (val) {
    return val === true;
  });
};

var anyOf = function anyOf() /*args*/{
  var args = Array.prototype.slice.call(arguments);

  return args.some(function (val) {
    return val === true;
  });
};

var getDefined = function getDefined(val, defaultVal) {
  return isDefined(val) ? val : defaultVal;
};

var notSingleEle = not(function ($ele) {
  return $ele.length === 1;
});

var each = function each(dataCanLoop, func, context) {
  var _context = existy(context) ? context : null;

  if (!(Array.isArray(dataCanLoop) || isString(dataCanLoop))) throw new TypeError('dataCanLoop parameter type of each() must be Array or String.');

  var result = false;
  for (var i = 0, max = dataCanLoop.length; i < max; i++) {
    result = func.call(_context, dataCanLoop[i]);
    if (result === false) break;
  }
};

var getFileExtension = function getFileExtension(fileName) {
  if (!isString(fileName)) throw new TypeError('getFileExtension() requires String parameter.');

  if (fileName.length <= 0) return '';

  var lastDotIndex = fileName.lastIndexOf('.'),
      extension = fileName.substr(lastDotIndex + 1);

  return extension;
};

var getFirstObjectHasProperty = function getFirstObjectHasProperty(arrayHasObjects, propertyKey, findPropertyValueOrRegex) {
  if (!Array.isArray(arrayHasObjects) || arrayHasObjects.length <= 0) return null;
  if (!isString(propertyKey)) return null;

  var obj = void 0,
      result = null;
  for (var i = 0, max = arrayHasObjects.length; i < max; ++i) {
    obj = arrayHasObjects[i];
    if (!obj.hasOwnProperty(propertyKey)) continue;

    if (isRegExp(findPropertyValueOrRegex)) {
      if (findPropertyValueOrRegex.test(obj[propertyKey])) {
        result = obj;
        break;
      }
    } else {
      if (obj[propertyKey] === findPropertyValueOrRegex) {
        result = obj;
        break;
      }
    }
  }
  return result;
};

var getObjectHasProperty = function getObjectHasProperty(arrayHasObjects, propertyKey) {
  if (!Array.isArray(arrayHasObjects) || arrayHasObjects.length <= 0) return null;
  if (!isString(propertyKey)) return null;
  var obj = void 0,
      result = null;

  each(arrayHasObjects, function (obj) {
    if (obj.hasOwnProperty(propertyKey)) result = obj[propertyKey];
  });
  //  console.log( '=> util.js getObjectHasProperty() result : ', propertyKey, result );
  return result;
};

var overlappedConditionSortByProperty = function sortByProp(_datas, _conditions, _conditionIndex) {
  var datas = Array.prototype.slice.call(_datas);

  if (!_conditions || _conditions.constructor !== Array || _conditions.length < 0) return datas;

  var conditionIndex = _conditionIndex >= 0 ? _conditionIndex : 0,
      condition = _conditions[conditionIndex];

  if (conditionIndex <= 0) datas.sort(condition.func);

  if (_conditions.length <= 1) return datas;

  if (conditionIndex < _conditions.length - 1) {
    var prevProperty = condition.property,
        nextConditionIndex = conditionIndex + 1,
        nextCondition = _conditions[nextConditionIndex];

    var memoObj = {},
        memoArr = [],
        arr = [];

    var obj = void 0,
        prop = void 0;
    for (var i = 0, max = datas.length; i < max; i++) {
      obj = datas[i];
      prop = String(obj[prevProperty]);

      if (!memoObj[prop]) {
        memoObj[prop] = [];
        memoArr.push(memoObj[prop]);
      }

      arr = memoObj[prop];
      arr.push(obj);
    }

    for (var j = 0, len = memoArr.length; j < len; j++) {
      arr = memoArr[j];
      arr.sort(nextCondition.func);

      memoArr[j] = overlappedConditionSortByProperty(arr, _conditions, nextConditionIndex);
    }

    var resultArr = memoArr.reduce(function (acc, curVal, curIndex, array) {
      return acc.concat(curVal);
    });

    return resultArr;
  }

  return datas;
};

var getPositionFromTranslateStr = function getPositionFromTranslateStr(str) {
  var obj = { x: 0, y: 0 };
  if (!isDefined(str)) return obj;

  var values = str.match(/[+-]?(\d*\.)?\d+/g);
  if (values.length <= 0) return obj;

  if (/translateX/g.test(str)) {
    obj.x = parseFloat(values[0]);
    return obj;
  }

  if (/translateY/g.test(str)) {
    obj.y = parseFloat(values[0]);
    return obj;
  }

  obj.x = parseFloat(values[0]);
  if (values.length > 1) obj.y = parseFloat(values[1]);

  return obj;
};

var isIndexInLoop = function isIndexInLoop(totalLength, loopGap, firstIndex, searchIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 4) throw Error('isIndexInLoop function requires 4 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(firstIndex) || !isInteger(searchIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || firstIndex < 1) {
    throw Error('totalLength and startIndex can not smaller than 1.');
  }
  if (loopGap > totalLength) {
    throw Error('loopGap can not bigger than totalLength.');
  }

  var index = firstIndex;
  for (var i = 0; i < loopGap; i++) {
    if (index === searchIndex) return true;
    index = index + 1 > totalLength ? 1 : index + 1;
  }

  return false;
};

var getLoopedLastIndex = function getLoopedLastIndex(totalLength, loopGap, firstIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 3) throw Error('getLoopedLastIndex function requires 3 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(firstIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || firstIndex < 1) {
    throw Error('totalLength and firstIndex can not smaller than 1.');
  }
  if (loopGap > totalLength || firstIndex > totalLength) {
    throw Error('loopGap and firstIndex can not bigger than totalLength.');
  }

  var index = firstIndex;
  for (var i = 0; i < loopGap - 1; i++) {
    index++;
    if (index > totalLength) index = 1;
  }
  return index;
};

var getReverseLoopedFirstIndex = function getReverseLoopedFirstIndex(totalLength, loopGap, lastIndex) {
  var args = Array.prototype.slice.call(arguments);
  if (args.length < 3) throw Error('getReverseLoopedFirstIndex function requires 3 arguments.');

  if (!isInteger(totalLength) || !isInteger(loopGap) || !isInteger(lastIndex)) {
    throw Error('arguments must be Integer Number.');
  }
  if (totalLength < 1 || lastIndex < 1) {
    throw Error('totalLength and lastIndex can not smaller than 1.');
  }
  if (loopGap > totalLength || lastIndex > totalLength) {
    throw Error('loopGap and lastIndex can not bigger than totalLength.');
  }

  var index = lastIndex;
  for (var i = 0; i < loopGap - 1; i++) {
    index = index - 1 < 1 ? totalLength : index - 1;
  }

  return index;
};

var getResolution = function getResolution() {
  var breakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { tablet: 640, pc: 960, max: 1260 };
  var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  var resolution = '';
  if (breakpoint.max && global.innerWidth >= breakpoint.max) {
    resolution = 'max';
  } else if (breakpoint.pc && global.innerWidth >= breakpoint.pc) {
    resolution = 'pc';
  } else if (breakpoint.tablet && global.innerWidth >= breakpoint.tablet) {
    resolution = 'tablet';
  } else {
    resolution = 'phone';
  }

  return resolution;
};

var isPhoneResolution = function isPhoneResolution(resolution) {
  return resolution === 'phone';
};

var isTabletResolution = function isTabletResolution(resolution) {
  return resolution === 'tablet';
};

var isMobileResolution = function isMobileResolution(resolution) {
  return resolution === 'phone' || resolution === 'tablet';
};

// http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
var numberWithCommas = function numberWithCommas(number) {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

var getUriParams = function getUriParams(uri) {
  if (uri.length < 1) return null;
  var str = uri.split('#')[0];

  var tmpArr = str.split('?');
  if (tmpArr.length < 2) return null;

  var paramStr = tmpArr[1],
      params = paramStr.split('&');

  var keyValueArr = void 0,
      obj = {};
  for (var i = 0, max = params.length; i < max; ++i) {
    keyValueArr = params[i].split('=');
    if (keyValueArr.length > 1) obj[keyValueArr[0]] = keyValueArr[1];

    // if (keyValueArr.length <= 1) return null;
    // obj[keyValueArr[0]] = keyValueArr[1];
  }
  return obj;
};

var getUriCombinedParams = function getUriCombinedParams(uri, params) {
  if (!uri) return '';
  if (!params) return uri;

  var str = '';
  for (var key in params) {
    str += '&' + key + '=' + String(params[key]);
  }
  if (str === '') return uri;

  var tmpArr = uri.split('#'),
      uri = tmpArr[0],
      hashStr = isDefined(tmpArr[1]) ? '#' + tmpArr[1] : '';

  uri = (uri.indexOf('?') >= 0 ? uri + str : uri + '?' + str.substr(1)) + hashStr;
  return uri;
};

var getHashParams = function getHashParams(hashStr) {
  var str = hashStr;
  if (str.length < 1) return null;

  var tmpArr = str.split('#');
  if (tmpArr.length < 2) return null;

  var paramStr = tmpArr[1],
      params = paramStr.split('&');

  var keyValueArr = void 0,
      obj = {};
  for (var i = 0, max = params.length; i < max; ++i) {
    keyValueArr = params[i].split('=');
    if (keyValueArr.length <= 1) return null;

    obj[keyValueArr[0]] = keyValueArr[1];
  }

  return obj;
};

var getHashCombinedParams = function getHashCombinedParams(uri, params) {
  if (!params) return uri;

  var str = '';
  for (var key in params) {
    str += '&' + key + '=' + String(params[key]);
  }
  if (str === '') return uri;

  uri = uri.indexOf('#') >= 0 ? uri + str : uri + '#' + str.substr(1);
  return uri;
};

var getObjForPagination = function getObjForPagination(totalPostNum, displayPostNumPerPage, displayPaginationBtnNum, pageIndex) {
  var args = Array.prototype.slice.call(arguments);

  if (args.length < 4) throw new Error('getObjForPagination() requires 4 parameters.');

  if (!isInteger(totalPostNum) || !isInteger(displayPostNumPerPage) || !isInteger(displayPaginationBtnNum) || !isInteger(pageIndex)) {
    throw new TypeError('getObjForPagination() requires Integer Number parameters.');
  }
  if (totalPostNum <= 0 || displayPostNumPerPage <= 0 || displayPaginationBtnNum <= 0 || pageIndex <= 0) {
    throw new TypeError('getObjForPagination() requires positive Integer Number parameters.');
  }

  var totalPageNum = Math.ceil(totalPostNum / displayPostNumPerPage);
  if (pageIndex < 1) pageIndex = 1;
  if (pageIndex > totalPageNum) pageIndex = totalPageNum;

  var paginationBtnGroupIndex = Math.floor((pageIndex - 1) / displayPaginationBtnNum),
      prevPageIndex = paginationBtnGroupIndex * displayPaginationBtnNum,
      firstPageIndex = paginationBtnGroupIndex * displayPaginationBtnNum + 1,
      lastPageIndex = firstPageIndex + displayPaginationBtnNum - 1,
      nextPageIndex = lastPageIndex + 1;

  if (lastPageIndex > totalPageNum) lastPageIndex = totalPageNum;
  if (nextPageIndex > totalPageNum) nextPageIndex = 0;

  return {
    totalPostNum: totalPostNum,
    displayPostNumPerPage: displayPostNumPerPage,
    displayPaginationBtnNum: displayPaginationBtnNum,
    pageIndex: pageIndex,

    totalPageNum: totalPageNum,
    prevPageIndex: prevPageIndex,
    firstPageIndex: firstPageIndex,
    lastPageIndex: lastPageIndex,
    nextPageIndex: nextPageIndex
  };
};

var getDivideIntStrByThousandUnit = function getDivideIntStrByThousandUnit(intStr_) {
  if (not(isDefined)(intStr_)) return ['0'];

  var DIVIDE_UNIT = 4;

  var intStr = String(parseStrIntToInt(intStr_)),
      intStrs = [];

  if (intStr.length <= DIVIDE_UNIT) return [String(intStr)];

  var lastIndex = 0,
      unitStr = '';
  while (intStr.length > DIVIDE_UNIT) {
    lastIndex = intStr.length;
    unitStr = intStr.substr(lastIndex - DIVIDE_UNIT, lastIndex);

    intStr = intStr.substr(0, lastIndex - DIVIDE_UNIT);
    intStrs.unshift(unitStr);
  }
  intStrs.unshift(intStr);

  return intStrs;
};

var getMarketPriceStr = function getMarketPriceStr(str) {
  var UNIT_PRICE = ['', '만', '억'];

  var val = isDefined(str) ? str : '0',
      unitValues = getDivideIntStrByThousandUnit(val);

  unitValues.reverse();

  var priceStr = '',
      unitVal = 0;
  for (var i = 0, max = unitValues.length; i < max; i++) {
    unitVal = parseInt10(unitValues[i]);
    if (unitVal <= 0) continue;

    priceStr = numberWithCommas(unitVal) + UNIT_PRICE[i] + priceStr;
    if (i !== unitValues.length) priceStr = ' ' + priceStr;
  }
  priceStr = priceStr.trim();

  if (!priceStr) return '0';
  return priceStr;
};

var getEmphasizedStrByQuery = function getEmphasizedStrByQuery(str, query) {
  return (str || '').split(query).join('<strong>' + query + '</strong>');
};

var getSeparatedDateStr = function getSeparatedDateStr(moment, dateStr) {
  var DAYS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    'Sunday': '일',
    'Monday': '월',
    'Tuesday': '화',
    'Wednesday': '수',
    'Thursday': '목',
    'Friday': '금',
    'Saturday': '토'
  };

  var val = '';

  var MIN_TO_SEC = 60,
      HOUR_TO_SEC = 3600,
      DAY_TO_SEC = 86400;

  var now = new Date(),
      past = new Date(dateStr),
      diffSeconds = Math.floor((now - past) / 1000);

  if (diffSeconds < DAY_TO_SEC) {
    if (diffSeconds < HOUR_TO_SEC) {
      if (diffSeconds < MIN_TO_SEC) {
        val = diffSeconds + '\uCD08 \uC804';
      } else {
        var diffMinutes = Math.floor(diffSeconds / MIN_TO_SEC);
        val = diffMinutes + '\uBD84 \uC804';
      }
    } else {
      var diffHours = Math.floor(diffSeconds / HOUR_TO_SEC);
      val = diffHours + '\uC2DC\uAC04 \uC804';
    }
  } else {
    var date = moment(dateStr),
        day = DAYS[date.format('dddd')] || '';

    val = date.format('YYYY-MM-DD');
    // val = date.format(`YYYY.MM.DD. (${day})`);
  }

  return val;
};

var namespace = function namespace(_namespace, parent) {
  if (!isString(_namespace)) throw new TypeError('namespace parameter type of namespace() must be String.');
  if (!(isObject(parent) || !isDefined(parent))) throw new TypeError('parent parameter type of namespace() must be Object or null or undefined.');

  var ns = parent || window;

  if (_namespace) {
    var parts = _namespace.split('.');

    for (var i = 0, max = parts.length; i < max; i++) {
      if (!ns[parts[i]]) ns[parts[i]] = {};
      ns = ns[parts[i]];
    }
  }

  return ns;
};

var template = function template(strings) {
  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals
  return function () {
    for (var _len2 = arguments.length, values = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      values[_key2] = arguments[_key2];
    }

    var dict = values[values.length - 1] || {};

    var result = [strings[0]];
    keys.forEach(function (key, i) {
      var value = Number.isInteger(key) ? values[key] : dict[key];
      result.push(value, strings[i + 1]);
    });

    return result.join('');
  };
};

// board - server list
var getUrlAddCategoryIdByArticle = function getUrlAddCategoryIdByArticle(_url, _article, _serverNameMap) {
  var url = _url;

  if (url !== '#') {
    var path = url.split('?')[0],
        uriParams = getUriParams(url);

    var categoryId = isObject(_article.category) ? _article.category.categoryId : uriParams.categoryId;

    if (isNotDefined(categoryId)) {
      // const obj = getFirstObjectHasProperty(_serverNameMap, 'serverId', 1) || _serverNameMap[0];
      // categoryId = obj.categoryId;
      categoryId = 0;
    }

    url = getUriCombinedParams(path, $.extend(uriParams, { categoryId: categoryId }));
  }

  return url;
};

// character setting - stat, equip simulator
var getChangedStats = function getChangedStats(originalStatObj, newStatObj) {
  var changedStats = {};

  var stat, newStat;
  for (var key in originalStatObj) {
    stat = isDefined(originalStatObj[key]) ? originalStatObj[key] : null;
    newStat = isDefined(newStatObj[key]) ? newStatObj[key] : null;

    if (allOf(isDefined(newStat), stat !== newStat)) changedStats[key] = newStat;
  }

  var changeStatsCount = 0;
  for (var k in changedStats) {
    changeStatsCount++;
  }return changeStatsCount > 0 ? changedStats : null;
};

// 2021.12 [StatModel.js] STEP_ELIXIR_POINT_BY_LEVEL = [{level: 80, point: 2 }, {level: 90, point: 2}, {level: 100, point: 3 }];
var getPlusElixirPointByLevel = function getPlusElixirPointByLevel(level, level_init, plusElixirPointByLevel) {
  var _plusElixirPoint = 0;
  if ((level - level_init) % 2 === 0) {
    _plusElixirPoint = 1;
  }
  each(plusElixirPointByLevel, function (obj) {
    if (parseInt(obj.level) === parseInt(level)) {
      _plusElixirPoint = parseInt(obj.point);
    }
  });
  // console.log( '=> util.js  _plusElixirPoint : ', _plusElixirPoint );
  return _plusElixirPoint;
};

// 2019.11 엘릭서를 사용할 수 없는 레벨 체크 50 이상이면 가능함 _.statData.level - _.model.LEVEL_INIT
var isLevelCanConsumeElixirStat = function isLevelCanConsumeElixirStat(level, perLevelPlusElixirPoint) {
  return level >= 0 ? true : false;
  // return (level % perLevelPlusElixirPoint === 0) ? true : false;
};

var isLevelGetElixirPoint = function isLevelGetElixirPoint(level, perLevelPlusElixirPoint) {
  // 2019.11
  return level % perLevelPlusElixirPoint === 0 ? true : false;
};

// STAT_MAX_BY_LEVEL 2021.
var getStatMaxByLevel = function getStatMaxByLevel(level, statMaxByLevel) {
  var _statMax = 50;
  each(statMaxByLevel, function (obj) {
    if (parseInt(obj.level) <= level) {
      _statMax = parseInt(obj.max);
    }
  });
  // console.log( '=> util.js getStatMaxByLevel() _statMax : ', _statMax );
  return _statMax;
};

var isWarrior = function isWarrior(classId) {
  if (parseInt10(classId) === 7) return true;

  return false;
};

var getClassName = function getClassName(classId) {
  var CLASS_NAMES_KOR = ['군주', '기사', '요정', '마법사', '다크엘프', '용기사', '환술사', '전사', '검사', '창기사'];

  var className = CLASS_NAMES_KOR[parseInt10(classId)];
  if (not(isDefined)(className)) className = '';

  return className;
};

var removeEquipInEquips = function removeEquipInEquips(equips, equipItemObj) {
  if (!Array.isArray(equips)) throw new TypeError('arr parameter type of removeEquipInEquips() must be Array.');

  var clonedEquips = equips.slice();

  var equip = void 0;
  for (var i = 0, max = clonedEquips.length; i < max; i++) {
    equip = clonedEquips[i];

    if (allOf(isDefined(equip), equip.id === equipItemObj.id, equip.name === equipItemObj.name, equip.slot === equipItemObj.slot)) {
      clonedEquips.splice(i, 1);
      break;
    }
  }

  return clonedEquips;
};

var isPetNecklace = function isPetNecklace(itemId) {
  return itemId === __WEBPACK_IMPORTED_MODULE_0__model_model__["d" /* PET_NECKLACE_ID */] ? true : false;
};

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BREAKPOINTS; });
/* unused harmony export DAYS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return API_DOMAIN_DEFAULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_COMMUNITY_DOMAIN; });
/* unused harmony export STATIC_DOMAIN_DEFAULT */
/* unused harmony export STATIC_CDN_DOMAIN_DEFAULT */
/* unused harmony export NO_ITEM_IMAGE_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PET_NECKLACE_ID; });
var BREAKPOINTS = {
  tablet: 640,
  pc: 960,
  max: 1340
};

var DAYS = {
  'Sunday': '일',
  'Monday': '월',
  'Tuesday': '화',
  'Wednesday': '수',
  'Thursday': '목',
  'Friday': '금',
  'Saturday': '토'
};

var API_DOMAIN_DEFAULT = 'https://api-lineage.plaync.com';

var API_COMMUNITY_DOMAIN = 'https://api-commnity.plaync.com/lineage1';

var STATIC_DOMAIN_DEFAULT = 'https://assets.playnccdn.com'; // https://wstatic.plaync.co.kr';

var STATIC_CDN_DOMAIN_DEFAULT = 'https://wstatic-cdn.plaync.com';

var NO_ITEM_IMAGE_URL = STATIC_DOMAIN_DEFAULT + '/lineage/v1/img/world/item/noimg.gif';

var PET_NECKLACE_ID = 25668;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getDatas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDatasWithOption; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleApiError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__model_msg_alert__ = __webpack_require__(3);


var getDatas = function getDatas(urls, resolvedCallback, rejectedCallback) {
  var promises = [];

  for (var i = 0, max = urls.length; i < max; i++) {
    var promise = $.ajax({
      type: 'GET',
      url: urls[i],
      dataType: 'json'
    });
    promises.push(promise);
  }

  $.when.apply($, promises).then(resolvedCallback).fail(rejectedCallback);
};

var getDatasWithOption = function getDatasWithOption(jQueryAjaxOptions, resolvedCallback, rejectedCallback) {
  var promises = [];

  for (var i = 0, max = jQueryAjaxOptions.length; i < max; i++) {
    var promise = $.ajax(jQueryAjaxOptions[i]);
    promises.push(promise);
  }

  $.when.apply($, promises).then(resolvedCallback).fail(rejectedCallback);
};

var handleApiError = function handleApiError(apiResultData) {
  var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;

  if (apiResultData) {
    if (parseInt(apiResultData.status, 10) === 401) {
      // http://git.korea.ncsoft.corp/projects/FRONTEND_DEVELOP/repos/uikit-nccommunity/browse/_src/js/lang.js
      global.alert(__WEBPACK_IMPORTED_MODULE_0__model_msg_alert__["a" /* ALERT */].REQUIRE_LOGIN);

      if (typeof global.GNBLogin === 'function') {
        global.GNBLogin();

        return true;
      }
    }
  }

  return false;
};



/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALERT; });
var ALERT = {
  REQUIRE_LOGIN: '로그인 후 이용하실 수 있습니다.'
};



/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * DropdownLayer - http://git.korea.ncsoft.corp/projects/FRONTEND_DEVELOP/repos/uikit-nccommunity/browse/_src/js/DropDownLayer.js
 */
// import Tmpl from 'js-template-string';

var DropdownLayer = function () {
  function DropdownLayer($node, data) {
    var _this = this;

    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'board';
    var className = arguments[3];

    _classCallCheck(this, DropdownLayer);

    this.$node = $node;
    this.name = name;
    this.listValue = '';
    this.$_node = jQuery(this.template(data, className));
    this.$node.append(this.$_node);
    this.$callback = $.Callbacks();

    this.dropDownLayer = '#' + this.name + ' .ui-dropdown-community';

    var dropdownLayer = this.dropDownLayer;
    var dropdownLayerTitle = dropdownLayer + ' .select';
    var dropdownLayerList = dropdownLayer + ' .option';

    // layer
    function toggleSelectLayer(parent) {
      var $p = parent;
      if ($p.hasClass('is-active')) {
        $p.removeClass('is-active');
      } else {
        jQuery(dropdownLayer).removeClass('is-active'); // select메뉴가 복수일 경우 모두 제거
        $p.addClass('is-active');
      }
    }

    //셀렉트메뉴 레이어: title 클릭 시 리스트 활성화/비활성화
    jQuery('body').on('click', dropdownLayerTitle, function (e) {

      if (jQuery(dropdownLayerTitle).hasClass('disabled')) return;

      var $parent = jQuery(dropdownLayerTitle).parent(dropdownLayer);

      toggleSelectLayer($parent);
    });

    //셀렉트메뉴 레이어: list 선택 시 title 변경
    jQuery('body').on('click', dropdownLayerList, function (e) {

      var $selectedDropdown = jQuery(dropdownLayerList).parent(dropdownLayer);
      var $eventTartget = jQuery(e.target);

      if ($eventTartget.hasClass('option')) return;

      _this.textValue = $eventTartget.text();
      _this.listValue = $eventTartget.data('value');

      toggleSelectLayer($selectedDropdown);

      jQuery(dropdownLayerList).siblings(dropdownLayerTitle).find('span').text(_this.textValue); // 타이틀 영역 텍스트 변경

      _this.$callback.fire(_this.listValue);

      //jQuery('input[type="hidden"]', $selectedDropdown).val(listValue).attr( 'data-value', textValue ).change(); // input 값 변경
    });

    //mobile
    jQuery('#' + this.name).on('change', 'select', function (evt) {
      var $eventTartget = jQuery(evt.target);
      _this.listValue = $eventTartget.val();

      _this.$callback.fire(_this.listValue);
    });

    //if document is clicked, hide modalLayer;
    jQuery('body').on('click', function (evt) {
      var container = jQuery(_this.dropDownLayer);
      if (!container.is(evt.target) && container.has(evt.target).length === 0) {
        var $parent = jQuery(dropdownLayerTitle).parent(dropdownLayer);
        $parent.removeClass('is-active');
      }
    });
  }

  _createClass(DropdownLayer, [{
    key: 'addChange',
    value: function addChange(callback) {
      this.$callback.add(callback);
    }
  }, {
    key: 'getNode',
    value: function getNode() {
      return this.$_node;
    }
  }, {
    key: 'setValue',
    value: function setValue() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (!val) return;

      var valueNode = jQuery(this.dropDownLayer).find('.option').find('[data-value="' + val + '"]');

      if (valueNode.length) {
        var text = jQuery(this.dropDownLayer).find('.option').find('[data-value="' + val + '"]').text();
        jQuery(this.dropDownLayer).find('.select').find('span').text(text || '');
        this.textValue = text;
        this.listValue = val;
        //mobile
        if (val) jQuery('#' + this.name).find('select').val(val);
      }
    }
  }, {
    key: 'setTextValue',
    value: function setTextValue() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (!val) return;

      var valueNode = jQuery(this.dropDownLayer).find('.option').find('[data-textvalue="' + val + '"]');

      if (valueNode.length) {
        var text = jQuery(this.dropDownLayer).find('.option').find('[data-textvalue="' + val + '"]').text();
        jQuery(this.dropDownLayer).find('.select').find('span').text(text || '');
        this.textValue = text;
        this.listValue = valueNode.attr('data-value');
        //mobile
        if (this.listValue) jQuery('#' + this.name).find('select').val(this.listValue);
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.listValue;
    }
  }, {
    key: 'template',
    value: function template(_data) {
      var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'board-category';

      /*
       let mobileList = Tmpl.iterate({
       data: _data,
       template: ( _v ) => `<option data-textvalue="${_v.value}" value="${_v.key}">${_v.value}</option>`
       });
         let pcList = Tmpl.iterate({
       data: _data,
       template: ( _v ) => `<li class="ui-dropdown-custom_items" data-textvalue="${_v.value}" data-value="${_v.key}">${_v.value}</li>`
       });
       */

      var mobileListTmpls = [],
          pcListTmpls = [];
      _data.forEach(function (item, idx) {
        mobileListTmpls.push('<option data-textvalue="' + item.value + '" value="' + item.key + '">' + item.value + '</option>');
        pcListTmpls.push('<li class="ui-dropdown-custom_items" data-textvalue="' + item.value + '" data-value="' + item.key + '">' + item.value + '</li>');
      });

      var mobileList = mobileListTmpls.join(''),
          pcList = pcListTmpls.join('');

      return '<div id="' + this.name + '" class="ui-dropdown-wrap ' + className + '">\n\t\t\t\t<!-- mobile -->\n\t\t\t\t<div class="ui-dropdown ui-dropdown-elements">\n\t\t\t\t\t<select name="' + className + '">\n\t\t\t\t\t\t' + mobileList + '\n\t\t\t\t\t</select>\n\t\t\t\t\t<i class="iconc iconc-arrow_down_s"></i>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- pc -->\n\t\t\t\t<div class="ui-dropdown ui-dropdown-community">\n\t\t\t\t\t<div class="select">\n\t\t\t\t\t\t<span>\uBD84\uB958</span>\n\t\t\t\t\t\t<i class="iconc iconc-arrow_down_s"></i>\n\t\t\t\t\t</div>\n\t\t\t\t\t<ul class="option">\n\t\t\t\t\t\t' + pcList + '\n\t\t\t\t\t</ul>\n\t\t\t\t</div>\n\t\t\t</div>';
    }
  }]);

  return DropdownLayer;
}();

// module.exports = DropdownLayer;


/* harmony default export */ __webpack_exports__["a"] = (DropdownLayer);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(7);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__servermaster_ServerMasterList__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__servermaster_ServerMasterWrite__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_model__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_Util__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__server_write_ServerWrite__ = __webpack_require__(13);







(function ($, global) {
  "use strict";

  Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["l" /* namespace */])('nc.lineage');
  var _device = window._device;
  var isServerMasterBoard = __WEBPACK_IMPORTED_MODULE_4__config_Util__["a" /* default */].ServerMasterBoard;
  var serverAlias = __WEBPACK_IMPORTED_MODULE_4__config_Util__["a" /* default */].getServerAlias;

  console.log('servermaster.js isServerMasterBoard : ', isServerMasterBoard);

  nc.lineage.serverMasterList = function (_board, options) {
    console.log('servermaster.js  serverMasterList function _board : ', _board);
    if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["k" /* isNotDefined */])(options)) throw new Error('nc.lineage.boardServerList constructor require options object');
    var option = $.extend(true, {
      wrap: $('#ncCommunityList'),
      apiDomain: window._communityApiPath,
      hostApiDomain: window._apiPath, // api-lineage
      isNCommunity: true,
      ncCommunityList: _board,
      isShowServerMasterArticles: true,
      serverAlias: options.serverAlias,
      device: _device,
      isIngame: false,
      global: global
    }, options);
    return new __WEBPACK_IMPORTED_MODULE_0__servermaster_ServerMasterList__["a" /* default */](option).init();
  };

  // write
  var _checkServerMasterWrite = function _checkServerMasterWrite(data) {
    console.log('onHookSubmitBefore(data) : ', __WEBPACK_IMPORTED_MODULE_1__servermaster_ServerMasterWrite__["a" /* default */]);
    console.log('onHookSubmitBefore(data) : ', data);
    if (__WEBPACK_IMPORTED_MODULE_1__servermaster_ServerMasterWrite__["a" /* default */]) __WEBPACK_IMPORTED_MODULE_1__servermaster_ServerMasterWrite__["a" /* default */].submitWriteData(data); // => call serverWrite.onSubmit(changedData) after change data
  };

  nc.lineage.serverMasterWrite = function (_board, options) {
    console.log('servermaster.js  serverMasterWrite function _board : ', _board);
    if (Object(__WEBPACK_IMPORTED_MODULE_2__utils_util__["k" /* isNotDefined */])(options)) throw new Error('nc.lineage.serverMasterWrite constructor require options object');
    var option = $.extend(true, {
      wrap: $('#ncCommunityWrite'),
      apiDomain: window._communityApiPath,
      hostApiDomain: window._apiPath, // api-lineage
      isNCommunity: true,
      ncCommunityWrite: _board,
      isShowServerMasterArticles: true,
      device: _device,
      isIngame: false,
      serverAlias: options.serverAlias,
      writeData: options.writeData,
      global: global
    }, options);
    return new __WEBPACK_IMPORTED_MODULE_1__servermaster_ServerMasterWrite__["a" /* default */](option).init();
  };
})(jQuery, window);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_service__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_model__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tpl__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ServerMasterNewArticle__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var ServerMasterList = function () {
    function ServerMasterList(options) {
        _classCallCheck(this, ServerMasterList);

        var _ = this;

        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["k" /* isNotDefined */])(options)) throw new Error('ServerList constructor require options object');

        _.option = $.extend({
            wrap: null,
            apiDomain: '' || __WEBPACK_IMPORTED_MODULE_2__model_model__["a" /* API_COMMUNITY_DOMAIN */],
            hostApiDomain: '' || __WEBPACK_IMPORTED_MODULE_2__model_model__["b" /* API_DOMAIN_DEFAULT */],
            ncCommunityList: null,

            isShowServerMasterArticles: false,
            isIngame: false,

            serverAlias: 0, // this is serverId

            global: window
        }, options);

        console.log('# serverlist _.option : ', _.option);

        _.wrap = _.option.wrap;

        _.serverId = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["n" /* parseInt10 */])(_.option.serverAlias);

        _.device = null;

        _.servermasterWrap = null;

        _.servermasterNewArticle = null;

        _.global = _.option.global;

        _.const = {
            MILLISECOND_TO_DAY: 1000 * 60 * 60 * 24
        };

        _.msg = {
            FAIL_LOAD_SERVERMASTER_DATA: '서버지기 데이터를 로드할 수 없습니다. 잠시 후 다시 시도해주세요.',
            FAIL_LOAD_MY_SERVERMASTER_ARTICLES: '우리 서버 최신 기사 데이터를 로드할 수 없습니다. 잠시 후 다시 시도해주세요.'
        };

        _.masters = [];
        _.flag = false;
        _.setServerId = 0;
    }

    _createClass(ServerMasterList, [{
        key: 'init',
        value: function init() {

            console.log('#serverList.js init()');
            var _ = this;

            if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["k" /* isNotDefined */])(_.option.ncCommunityList)) throw new Error('ServerList constructor require options has ncCommunityList parameter');

            // 검색 결과에서는 서버지기 노출되지않음
            var uriParams = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["g" /* getUriParams */])(document.location.href) || {},
                metaTags = uriParams.metaTags; // metaTags
            if (metaTags) return;

            // after initialize ncCommunityList, call setInstance method

            // _.option.ncCommunityList.onLoaded.add(_.setInstance, _);

            _.setInstance();
            return _;
        }
    }, {
        key: 'setInstance',
        value: function setInstance() {
            var _ = this;

            _.setServerId = _.getServerId();

            console.log('#serverList.js setInstance() _.masters.length , _.setServerId ', _.masters.length, _.setServerId, parseInt(_.setServerId) == 0);

            if (_.masters.length <= 0) {

                // api - http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=97027727
                // api/servermaster/1/isServerMaster
                Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["a" /* getDatasWithOption */])([{
                    type: 'GET',
                    contentType: 'application/json',
                    dataType: 'json',
                    url: _.option.hostApiDomain + 'api/servermaster/serverMastersByServerId?serverId=' + _.getServerId()
                    // data: {serverId: _.getServerId()}

                }], function (masters) {

                    console.log(masters);

                    _.masters = masters;
                    _.setContents();
                }, function (data) {
                    _.setContents();
                });
            } else {
                _.setContents();
            }
        }
    }, {
        key: 'setContents',
        value: function setContents() {
            var _ = this;

            _.setMasterWrittenItemColor();

            // my server new articles
            var uriParams = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["g" /* getUriParams */])(document.location.href) || {};

            console.log('#ServerMasterList.js  _.global._serverNameMap, _.serverId ', _.global._serverNameMap, _.serverId);

            var _getInitServerName = _.global._boardCategoryMap ? Object.getOwnPropertyNames(_.global._boardCategoryMap[0]) : ['데포로쥬'];
            var _getServerName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["d" /* getFirstObjectHasProperty */])(_.global._serverNameMap, 'serverId', _.serverId) ? Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["d" /* getFirstObjectHasProperty */])(_.global._serverNameMap, 'serverId', _.serverId).serverName : null;
            var _serverName = _getServerName ? _getServerName : _getInitServerName[0];
            var _categoryId = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["e" /* getObjectHasProperty */])(_.global._boardCategoryMap, _serverName);

            var categoryId = uriParams.categoryId || _categoryId;
            var metaTags = uriParams.metaTags;

            console.log('# serverList.js setContents(), serverName, Category', _serverName, _categoryId, categoryId);

            if (!categoryId) return;
            if (metaTags) return;

            if (categoryId <= 0) {
                // all server. don't set servermaster article UI

            } else {
                // some server
                if (!_.flag) if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["o" /* truthy */])(_.option.isShowServerMasterArticles)) _.setServermasterArticles();
            }

            _.flag = true;
        }
    }, {
        key: 'setMasterWrittenItemColor',
        value: function setMasterWrittenItemColor() {

            console.log('#serverlist.js setMasterWrittenItemColor() start');
            var _ = this;

            var $masterList = $('.ncCommunityBoardList .board-items', _.wrap).filter(function () {
                console.log('data-master attribute value :', $(this).is('[data-is-master]'));
                return $(this).is('[data-is-master]');
            });

            if ($masterList.length <= 0) {
                // no item server master have written
                console.log('no item which server master have written');
                return;
            }

            if (_.masters.length <= 0) {
                console.log('no server master in this server');
                return;
            }

            // has item master have written

            var mastersCash = {};

            console.log('#serverlist.js setMasterWrittenItemColor() $masterList : ', $masterList);

            $masterList.each(function (index, value) {
                var nameNode = $('.board-meta .name', value).contents().filter(function (i, v) {
                    // isDefaultViewMode: "classic" 일경우, compact 모드일경우는 셀렉터가 다름
                    return v.nodeType === Node.TEXT_NODE;
                }),
                    name = nameNode.text(),
                    masterObj = mastersCash[name] || Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["d" /* getFirstObjectHasProperty */])(_.masters, 'characterName', name);

                if (masterObj) {
                    // server master has name
                    $(value).attr('data-is-master', masterObj.category.toLowerCase()); // review, column, coverage

                    if (!mastersCash[name]) mastersCash[name] = masterObj;
                }
            });
        }
    }, {
        key: 'setServermasterArticles',
        value: function setServermasterArticles() {
            var _ = this;
            console.log('# serverList.js setServermasterArticles(), start');

            // servermaster section
            $('#boardTopUtils').after('<div class="wrap-servermaster"><a class="btn-servermaster" href="/servermaster/index">서버지기 모집안내</a><div class="wrap-section-servermaster"></div></div>');

            _.servermasterParent = $('.wrap-servermaster');
            _.servermasterWrap = $('.wrap-section-servermaster');

            if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["c" /* falsy */])(_.option.isIngame)) {
                // pc, mobile

                // set my server masters - modify 5/3
                _.setMyServerMaster(_.masters);

                if (_.option.device === 'pc' || _.option.device === 'launcher') _.servermasterWrap.append(Object(__WEBPACK_IMPORTED_MODULE_3__tpl__["b" /* getServermasterNewArticleTpl */])());

                // get servermaster new articles
                Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["a" /* getDatasWithOption */])([{
                    type: 'GET',
                    contentType: 'application/json',
                    url: _.option.apiDomain + 'board/server/article/search/moreArticle',
                    dataType: 'json',
                    data: {
                        moreSize: 12,
                        // page: 1,
                        // query: '서버지기',
                        // searchType: 'metaTags',
                        metaTags: 'servermaster',
                        categoryId: 0, // all server board category id
                        summary: false
                    },
                    xhrFields: { withCredentials: true }

                }], function (articleData) {

                    console.log('# serverlist.js setServermasterArticles() articleData : ', articleData);

                    _.servermasterParent.addClass(_.option.device);

                    _.servermasterNewArticle = new __WEBPACK_IMPORTED_MODULE_4__ServerMasterNewArticle__["a" /* default */]({
                        wrap: $('.section-servermaster', _.servermasterWrap),
                        device: _.option.device,
                        data: articleData
                    }).init();

                    // set my server masters
                    /* _.setMyServerMaster(_.masters); */
                }, function (data) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["c" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["b" /* handleApiError */])(data))) _.global.alert(_.msg.FAIL_LOAD_SERVERMASTER_DATA); // '서버지기 데이터를 로드할 수 없습니다. 잠시 후 다시 시도해주세요.'
                });
            } else {
                // ingame
                _.servermasterWrap.addClass('is-ingame');

                // set servermaster new articles
                if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["m" /* not */])(Array.isArray)(_.masters)) {
                    // no process
                } else {
                    if (_.masters.length <= 0) {
                        _.servermasterWrap.remove();
                    } else {
                        _.setMyServerMaster(_.masters);
                    }
                }
            }
        }
    }, {
        key: 'setMyServerMaster',
        value: function setMyServerMaster(_data) {
            var _ = this,
                data = _data || [];

            console.log('serverList.js setMyServerMaster() _.setServerId : ', _.setServerId, parseInt(_.setServerId) == 0);
            if (data.length <= 0 || parseInt(_.setServerId) == 0) return;

            // set my server servermaster

            _.servermasterParent.addClass('has-servermaster');
            _.servermasterWrap.append(Object(__WEBPACK_IMPORTED_MODULE_3__tpl__["a" /* getMyServermasterTpl */])());

            // my server masters
            var tpl = '';
            Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["b" /* each */])(data, function (item) {
                tpl += '<li><span class="flag ' + item.category + '"></span> ' + item.characterName + ' </li>';
            });

            $('.section-servermaster-my .article-myservermaster ul', _.servermasterWrap).append(tpl);

            // my server new articles
            var uriParams = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["g" /* getUriParams */])(document.location.href) || {};

            //let _serverName = getFirstObjectHasProperty(_.global._serverNameMap, 'serverId', _.serverId).serverName;
            //let _categoryId = getObjectHasProperty(_.global._boardCategoryMap , _serverName);
            var _getInitServerName = _.global._boardCategoryMap ? Object.getOwnPropertyNames(_.global._boardCategoryMap[0]) : ['데포로쥬'];
            var _getServerName = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["d" /* getFirstObjectHasProperty */])(_.global._serverNameMap, 'serverId', _.serverId) ? Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["d" /* getFirstObjectHasProperty */])(_.global._serverNameMap, 'serverId', _.serverId).serverName : null;
            var _serverName = _getServerName ? _getServerName : _getInitServerName[0];
            var _categoryId = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["e" /* getObjectHasProperty */])(_.global._boardCategoryMap, _serverName);

            var categoryId = uriParams.categoryId || _categoryId;

            console.log('# serverList.js setMyServerMaster(), serverName, Category', _serverName, _categoryId, categoryId);

            /*if (isNaN(categoryId)) {
              categoryId = getFirstObjectHasProperty(_.global._serverNameMap, 'serverId', _.serverId).categoryId || _.global._serverNameMap[0].categoryId;
            }*/

            Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["a" /* getDatasWithOption */])([{
                type: 'GET',
                contentType: 'application/json',
                url: _.option.apiDomain + 'board/server/article/search/moreArticle',
                dataType: 'json',
                data: {
                    moreSize: 3,
                    // page: 1,
                    // query: '서버지기',
                    // searchType: 'metaTags',
                    metaTags: 'servermaster',
                    categoryId: categoryId,
                    summary: false
                },
                xhrFields: { withCredentials: true }

            }], function (articleData) {

                console.log('# serverList.js setMyServerMaster() articleData.contentList: ', articleData.contentList);

                if (Array.isArray(articleData.contentList) && articleData.contentList.length > 0) {
                    var _tpl = '',
                        url = void 0;
                    Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["b" /* each */])(articleData.contentList, function (article) {
                        var diff = new Date(_.global.userData.now).getTime() - new Date(article.postDate).getTime(),
                            newIconTpl = diff < _.const.MILLISECOND_TO_DAY ? ' <i class="fe-icon-new"></i> ' : '';

                        /* let url = (article.url || '').split('/').pop() || '#';
                        url = getUrlAddCategoryIdByArticle(url, article, _.global._serverNameMap); // */
                        url = 'view?categoryId=' + article.categoryBoard.id + '&articleId=' + article.id;

                        _tpl += '<li><a class="title" href="' + url + '">' + article.title + newIconTpl + '</a><span class="writer">' + article.writer.gameUser.gameCharacterName + '</span></li>';
                    });

                    $('.section-servermaster-my .article-list ul', _.servermasterWrap).append(_tpl);
                } else {
                    $('.section-servermaster-my .article-list ul', _.servermasterWrap).append('<li class="nodata">\uC791\uC131\uB41C \uAE30\uC0AC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4.</li>');
                }
            }, function (data) {
                if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["c" /* falsy */])(Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["b" /* handleApiError */])(data))) _.global.alert(_.msg.FAIL_LOAD_MY_SERVERMASTER_ARTICLES); // '우리 서버 최신 기사 데이터를 로드할 수 없습니다. 잠시 후 다시 시도해주세요.'
            });
        }
    }, {
        key: 'getServerId',
        value: function getServerId() {
            var _ = this;

            var selectedOption = null,
                dropdownCategoryId = null,
                dropdownServerName = null;
            if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["a" /* anyOf */])($('body').hasClass('mobile'), $('body').hasClass('tablet'))) {
                // mobile device
                selectedOption = $('#boardCategory .ui-dropdown-elements select option:selected');
                dropdownCategoryId = selectedOption.val();
                dropdownServerName = selectedOption.text();
            } else {
                // pc device
                var dropdownSelectedServerName = $('.board-top-category .ui-dropdown > span').text(),
                    dropdownOptions = $('.board-top-category .ui-dropdown .option li');

                for (var i = 0, max = dropdownOptions.length; i < max; i++) {
                    if ($(dropdownOptions.get(i)).text() === dropdownSelectedServerName) {
                        selectedOption = $(dropdownOptions.get(i));
                        break;
                    }
                }
                dropdownCategoryId = selectedOption.attr('data-value');
                dropdownServerName = selectedOption.attr('data-textvalue');
            }

            // my server new articles
            var uriParams = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["g" /* getUriParams */])(document.location.href) || {},
                categoryId = uriParams.categoryId;

            var serverId = 0;

            if (categoryId) {
                var data = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["d" /* getFirstObjectHasProperty */])(_.global._serverNameMap, 'serverName', dropdownServerName) || {};
                serverId = data.serverId || 0; // some server id || 'all'
            } else {
                serverId = _.serverId || 0; // if (isNotDefined(_.global.userData) || isNotDefined(_.global.userData.gameAccount) || _.global.userData.gameAccount.serverId !== '') serverId = _.global.userData.gameAccount.serverId;
            }

            return serverId;
        }
    }]);

    return ServerMasterList;
}();

/* harmony default export */ __webpack_exports__["a"] = (ServerMasterList);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getServermasterNewArticleTpl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMyServermasterTpl; });
var getServermasterNewArticleTpl = function getServermasterNewArticleTpl(data) {
  return "<section class=\"section-servermaster\">\n              <header>\n                <h3>\uC804\uCCB4 \uC11C\uBC84\uC9C0\uAE30 \uCD5C\uC2E0\uAE30\uC0AC</h3>\n              </header>\n              <article class=\"article-list\"></article>\n            </section>";
};

var getMyServermasterTpl = function getMyServermasterTpl(data) {
  return "<section class=\"section-servermaster-my\">\n            <header>\n              <h3>\uC6B0\uB9AC\uC11C\uBC84 \uC11C\uBC84\uC9C0\uAE30&\uCD5C\uC2E0\uAE30\uC0AC</h3>\n            </header>\n            <article class=\"article-myservermaster\">\n              <ul class=\"has-6\">\n                <!--\n                <li><span class=\"flag COVERAGE\"></span> servermaster name </li>\n                <li><span class=\"flag COLUMN\"></span> servermaster name </li>\n                <li><span class=\"flag REVIEW\"></span> servermaster name </li>\n                -->\n              </ul>\n            </article>\n\n            <header>\n              <h3>\uC6B0\uB9AC\uC11C\uBC84 \uCD5C\uC2E0\uAE30\uC0AC</h3>\n            </header>\n            <article class=\"article-list\">\n              <ul>\n                <!-- <li><a class=\"title\" href=\"\">title</a><span class=\"writer\">character name</span></li> -->\n              </ul>\n            </article>\n          </section>";
};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__model_model__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var ServerMasterNewArticle = function () {
  function ServerMasterNewArticle(options) {
    _classCallCheck(this, ServerMasterNewArticle);

    var _ = this;

    _.option = $.extend({
      wrap: null,
      data: null,
      breakpoint: __WEBPACK_IMPORTED_MODULE_1__model_model__["c" /* BREAKPOINTS */],
      global: window
    }, options);

    _.global = _.option.global;

    _.data = _.option.data;

    _.wrap = $(_.option.wrap);
    _.device = _.option.device;

    _.articleWrap = _.device === 'pc' || _.device === 'launcher' ? $('.article-list', _.wrap) : $('.wrap-section-servermaster');

    _.currentResolution = '';

    _.const = {
      NUM_LIST_PER_SECTION_IN_NEW_ARTICLE: 6
    };
  }

  _createClass(ServerMasterNewArticle, [{
    key: 'init',
    value: function init() {
      var _ = this;

      /* TEST  _.setNewArticleExtendBtn(); */

      if (_.device === 'pc' || _.device === 'launcher') {
        _.setTpl();
        if ($('> ul', _.articleWrap).length <= 1 || !Object(__WEBPACK_IMPORTED_MODULE_0__utils_util__["i" /* isFunction */])(_.articleWrap.slick)) return;
      } else {
        _.setMobileTpl();
        if ($('> section', _.articleWrap).length <= 1 || !Object(__WEBPACK_IMPORTED_MODULE_0__utils_util__["i" /* isFunction */])(_.articleWrap.slick)) return;
      }

      _.currentResolution = Object(__WEBPACK_IMPORTED_MODULE_0__utils_util__["f" /* getResolution */])(_.option.breakpoint, _.global);

      if (!Object(__WEBPACK_IMPORTED_MODULE_0__utils_util__["j" /* isMobileResolution */])(_.currentResolution)) {
        // pc/max resolution
        _.setServermasterArticlesSlick(_.articleWrap);
      }

      $(_.global).on('resize', $.proxy(_.resize, _));
      _.resize();
    }

    /* TEST
    setNewArticleExtendBtn() {
      const _ = this;
        $('.btn-extend', _.servermasterWrap).on('click', function (evt) {
        $(this).toggleClass("extend");
          _.articleWrap.toggleClass("extend");
      });
    }
    */

  }, {
    key: 'setTpl',
    value: function setTpl() {
      var _ = this,
          sectionNum = Math.ceil(_.data.contentList.length / _.const.NUM_LIST_PER_SECTION_IN_NEW_ARTICLE);

      var index = 0,
          articles = void 0,
          $tpl = void 0,
          diff = void 0,
          newIconTpl = void 0,
          url = void 0;
      for (var i = 0, max = sectionNum; i < max; i++) {
        articles = _.data.contentList.slice(index, _.const.NUM_LIST_PER_SECTION_IN_NEW_ARTICLE * (i + 1));

        $tpl = $('<ul>');

        // set new servermaster articles
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_util__["b" /* each */])(articles, function (article) {
          diff = new Date(_.global.userData.now).getTime() - new Date(article.postDate).getTime();
          newIconTpl = diff < _.const.MILLISECOND_TO_DAY ? ' <i class="fe-icon-new"></i> ' : '';

          /*url = (article.url || '').split('/').pop() || '#';
          url = getUrlAddCategoryIdByArticle(url, article, _.global._serverNameMap);*/
          url = 'view?categoryId=' + article.categoryBoard.id + '&articleId=' + article.id;

          $tpl.append('<li><a class="title" href="' + url + '">' + article.title + newIconTpl + '</a><span class="writer">' + article.writer.gameUser.gameCharacterName + '</span></li>');
        });

        _.articleWrap.append($tpl);

        index = _.const.NUM_LIST_PER_SECTION_IN_NEW_ARTICLE * (i + 1);
      }
    }
  }, {
    key: 'setMobileTpl',
    value: function setMobileTpl() {
      var _ = this,
          sectionNum = Math.ceil(_.data.contentList.length / _.const.NUM_LIST_PER_SECTION_IN_NEW_ARTICLE);

      var index = 0,
          articles = void 0,
          $tpl = void 0,
          diff = void 0,
          newIconTpl = void 0,
          url = void 0,
          $tpl_parent = void 0;
      for (var i = 0, max = sectionNum; i < max; i++) {
        articles = _.data.contentList.slice(index, _.const.NUM_LIST_PER_SECTION_IN_NEW_ARTICLE * (i + 1));

        $tpl_parent = $('\n    <section class="section-servermaster">\n          <header><h3>\uC804\uCCB4 \uC11C\uBC84\uC9C0\uAE30 \uCD5C\uC2E0\uAE30\uC0AC</h3></header>\n      <article class="article-list">\n          <ul></ul></article>\n          </section>\n          ');

        $tpl = $('<ul>');

        // set new servermaster articles
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_util__["b" /* each */])(articles, function (article) {
          diff = new Date(_.global.userData.now).getTime() - new Date(article.postDate).getTime();
          newIconTpl = diff < _.const.MILLISECOND_TO_DAY ? ' <i class="fe-icon-new"></i> ' : '';

          /*url = (article.url || '').split('/').pop() || '#';
          url = getUrlAddCategoryIdByArticle(url, article, _.global._serverNameMap);*/
          url = 'view?categoryId=' + article.categoryBoard.id + '&articleId=' + article.id;

          $tpl_parent.find('.article-list ul').append('<li><a class="title" href="' + url + '">' + article.title + newIconTpl + '</a><span class="writer">' + article.writer.gameUser.gameCharacterName + '</span></li>');
        });

        /* TEST
         _.articleWrap.append($tpl);
        */
        $(".wrap-section-servermaster").append($tpl_parent);

        index = _.const.NUM_LIST_PER_SECTION_IN_NEW_ARTICLE * (i + 1);
      }
    }
  }, {
    key: 'setServermasterArticlesSlick',
    value: function setServermasterArticlesSlick($wrap) {
      if (this.isSlickWrapInitialized($wrap)) return;

      $wrap.slick({
        dots: true,
        speed: 250,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000
      });
    }
  }, {
    key: 'resize',
    value: function resize(evt) {
      var _ = this,
          resolution = Object(__WEBPACK_IMPORTED_MODULE_0__utils_util__["f" /* getResolution */])(_.option.breakpoint, _.global),
          isSlickInitialized = _.isSlickWrapInitialized(_.articleWrap);

      if (isSlickInitialized) _.articleWrap.slick('resize');

      _.setServermasterArticlesSlick(_.articleWrap);

      /* TEST
      if (resolution !== _.currentResolution) {
        const isCurrentMobileRes = isMobileResolution(_.currentResolution),
            isMobileRes = isMobileResolution(resolution);
          if (isCurrentMobileRes && !isMobileRes) {
          // change phone/tablet to pc/max
          _.setServermasterArticlesSlick(_.articleWrap);
          } else if (!isCurrentMobileRes && isMobileRes) {
          // change pc/max to phone/tablet
          // 06 if (isSlickInitialized) _.articleWrap.slick('unslick');
          }
      }
      _.currentResolution = resolution;
      */
    }
  }, {
    key: 'isSlickWrapInitialized',
    value: function isSlickWrapInitialized($wrap) {
      if ($wrap.length) return $wrap.hasClass('slick-initialized');

      return false;
    }
  }]);

  return ServerMasterNewArticle;
}();

/* harmony default export */ __webpack_exports__["a"] = (ServerMasterNewArticle);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_service__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_msg_alert__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_model__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vendor_nccommunity_DropDownLayer__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





 // http://git.korea.ncsoft.corp/projects/FRONTEND_DEVELOP/repos/uikit-nccommunity/browse/_src/js/DropDownLayer.js

var ServerMasterWrite = function () {
  function ServerMasterWrite(options) {
    _classCallCheck(this, ServerMasterWrite);

    var _ = this;

    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["k" /* isNotDefined */])(options)) throw new Error('ServerWrite constructor require options object');

    // _.GAP_SERVER_ID = 47; // opdev: 50, rc: 47

    _.option = $.extend({
      wrap: null,
      apiDomain: '' || __WEBPACK_IMPORTED_MODULE_3__model_model__["b" /* API_DOMAIN_DEFAULT */],
      hostApiDomain: '' || __WEBPACK_IMPORTED_MODULE_3__model_model__["b" /* API_DOMAIN_DEFAULT */],
      ncCommunityWrite: null,
      isIngame: false,
      serverAlias: 1,
      serverName: null,
      writeData: null,
      global: window
    }, options);

    _.global = _.option.global;

    _.wrap = _.option.wrap;

    _.serverId = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["n" /* parseInt10 */])(_.option.serverAlias);
    _.serverName = _.option.serverName;

    _.serverMasterDropdown = null;

    _.ncCommunityWrite = _.option.ncCommunityWrite;

    _.msg = {
      NO_SERVER_ID: '글을 등록할 서버를 찾을 수 없습니다.',
      NOT_MASTER_IN_SERVER: '이 캐릭터는 해당 서버의 서버지기가 아닙니다.'
    };

    _.isEdit = false;
    _.writeData = _.option.writeData;
  }

  _createClass(ServerMasterWrite, [{
    key: 'init',
    value: function init() {
      var _ = this;

      console.log('serverMasterWrite.js init ');
      _.setInstance(_.writeData);

      // if (isNotDefined(_.option.ncCommunityWrite)) throw new Error('ServerWrite constructor require options has ncCommunityWrite parameter');

      // after initialize ncCommunityWrite, call setInstance method
      // _.option.ncCommunityWrite.onLoaded.add(_.setInstance, _);

      console.log(' serverMasterWrite.js _ : ', _.writeData);

      return _;
    }
  }, {
    key: 'setInstance',
    value: function setInstance(writeData) {
      // 1. write new : undefined
      // 2. rewrite(edit) : { title, contents, serverMaster }

      var _ = this;

      // there is item which server master have written
      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["o" /* truthy */])(_.option.isIngame)) {
        // ingame - no processwriteData

      } else {
        // pc, mobile
        // api - http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=97027727


        Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["a" /* getDatasWithOption */])([{
          type: 'GET',
          url: _.option.hostApiDomain + 'api/servermaster/' + _.serverId + '/isServerMaster',
          dataType: 'json',
          xhrFields: { withCredentials: true }

        }], function (data) {
          console.log('isServerMasterSuccess :', data);

          // if user character is server master
          if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(data) && data.result === true) {
            // append server master dropdown
            _.setServerMasterDropdown();

            console.log('servermaster.js setInstance() writeData : ', writeData);
            if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["k" /* isNotDefined */])(writeData)) {
              console.log('write new article : ', writeData);

              _.serverMasterDropdown.setTextValue('일반');
            } else {
              console.log('rewrite article (edit) :', writeData);
              _.isEdit = true;

              if (writeData.serverMaster) {
                // 202005
                // server master have written
                _.serverMasterDropdown.setTextValue('서버지기');
              } else {
                // normal
                _.serverMasterDropdown.setTextValue('일반');
              }
            }
          }
        }, function (data) {
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["b" /* handleApiError */])(data);
        });
      }
    }
  }, {
    key: 'setServerMasterDropdown',
    value: function setServerMasterDropdown() {
      var _ = this,
          dropdownWrap = $('<div class="board-write-category-servermaster"></div>');

      $('.board-write-title').before(dropdownWrap);

      _.serverMasterDropdown = new __WEBPACK_IMPORTED_MODULE_4__vendor_nccommunity_DropDownLayer__["a" /* default */](dropdownWrap, [{ 'key': 'normal', value: '일반' }, { 'key': 'servermaster', value: '서버지기' }], 'boardServerMaster');
    }
  }, {
    key: 'setServerDropdown',
    value: function setServerDropdown() {
      var _ = this;
      var userData = global.userData || null;

      var selectedOption = null,
          dropdownCategoryId = null,
          dropdownServerName = null;

      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["a" /* anyOf */])($('body').hasClass('mobile'), $('body').hasClass('tablet'))) {
        // mobile device
        selectedOption = $('#boardWriteForm .ui-dropdown-elements select option:selected');
        dropdownCategoryId = selectedOption.val();
        dropdownServerName = selectedOption.text();
      } else {
        // pc device
        var dropdownOptions = $('#boardWriteForm .ui-dropdown-community .option li');
        dropdownServerName = $('#boardWriteForm .board-write-category .ui-dropdown-community .select > span').text();

        for (var i = 0, max = dropdownOptions.length; i < max; i++) {
          if ($(dropdownOptions.get(i)).attr('data-textValue') === dropdownServerName) {
            selectedOption = $(dropdownOptions.get(i));
            break;
          }
        }

        console.log('selectedOption : ', selectedOption, selectedOption.attr('data-textValue'), selectedOption.attr('data-value'));

        dropdownCategoryId = selectedOption.attr('data-value');
        dropdownServerName = selectedOption.attr('data-textValue');
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["k" /* isNotDefined */])(userData) || Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["c" /* falsy */])(userData.isLogin)) return;
      if (userData.gameAccount.serverName != dropdownServerName) {
        _.global.alert(_.msg.NO_SERVER_ID); // '글을 등록할 서버를 찾을 수 없습니다.'
        return false;
      }

      return true;
    }
  }, {
    key: 'submitWriteData',
    value: function submitWriteData(data) {
      var _ = this;

      var sendData = null;
      console.log('#servermasterwrite.js submitWriteData(), isDefined(_.option.ncCommunityWrite) :', Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(_.option.ncCommunityWrite));

      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["o" /* truthy */])(_.option.isIngame)) {
        // ingame
        sendData = data;

        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(_.option.ncCommunityWrite)) _.option.ncCommunityWrite.onSubmit(sendData);
      } else {
        // pc, mobile
        sendData = $.extend(true, {
          servermaster: Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(_.serverMasterDropdown) && _.serverMasterDropdown.getValue() === 'servermaster' ? true : false
        }, data);

        console.log('#servermasterwrite.js submitWriteData(), sendData :', sendData);
        console.log('#servermasterwrite.js submitWriteData(), if : ', _.isEdit);
        console.log('#servermasterwrite.js submitWriteData(), if : ', Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(_.serverMasterDropdown) && _.serverMasterDropdown.getValue() === 'servermaster');

        // check character is server's server master. // ! _.isEdit &&
        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(_.serverMasterDropdown) && _.serverMasterDropdown.getValue() === 'servermaster') {
          // api - http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=97027727
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["a" /* getDatasWithOption */])([{
            type: 'GET',
            url: _.option.hostApiDomain + 'api/servermaster/' + _.serverId + '/isServerMaster',
            dataType: 'json',
            xhrFields: { withCredentials: true }

          }], function (data) {
            console.log('isServerMasterSuccess, data.result :', data.result);

            // if user character is server master
            if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(data) && data.result === true) {
              // console.log('user character is servermaster in this server');
              sendData.serverMaster = true;
              console.log('서버지기글로 작성 sendData.serverMaster : ', sendData.serverMaster);

              if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(_.option.ncCommunityWrite)) _.option.ncCommunityWrite.onSubmit(sendData);
            } else {
              console.log('user character is not !!! servermaster in this server');
              _.global.alert(_.msg.NOT_MASTER_IN_SERVER); // '이 캐릭터는 해당 서버의 서버지기가 아닙니다.'

              if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["i" /* isFunction */])(_.ncCommunityWrite.enableWriteButton)) _.ncCommunityWrite.enableWriteButton();
            }
          }, function (data) {
            Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["b" /* handleApiError */])(data);
          });
        } else {
          // there is not server master dropdown, or user is not server master.
          sendData.serverMaster = false;
          console.log('일반글로 작성 sendData.serverMaster : ', sendData.serverMaster);
          // alert( sendData.serverMaster );
          if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(_.option.ncCommunityWrite)) _.option.ncCommunityWrite.onSubmit(sendData);
        }
      }
    } // submitWriteData()

  }]);

  return ServerMasterWrite;
}();

/* harmony default export */ __webpack_exports__["a"] = (ServerMasterWrite);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_util__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import { API_DOMAIN_DEFAULT } from '../../model/model';
// import { BoardName } from './Model';


var Utils = function () {
	function Utils() {
		_classCallCheck(this, Utils);
	}

	_createClass(Utils, null, [{
		key: 'HookSubmitBefore',
		value: function HookSubmitBefore(data) {

			if (serverWrite) serverWrite.submitWriteData(data);
			console.log('Utils.js > HookSubmitBefore: ', data);
		}
	}, {
		key: 'HookWriteBefore',
		value: function HookWriteBefore() {

			var _board = window._boardConfig.board;

			function isBBSBanned() {
				// 글쓰기 제재 상태 체크
				var BBSBannedStatus = void 0;
				$.ajax({
					type: 'GET',
					url: window._communityApiPath + 'board/writer/is-bbs-banned',
					async: false,
					dataType: 'json',
					contentType: 'application/json',
					xhrFields: { withCredentials: true },
					success: function success(data) {
						if (data) {
							BBSBannedStatus = true;
						} else {
							BBSBannedStatus = false;
						}
					},
					error: function error(data) {
						window.alert('잠시 후, 다시 시도해주세요.');
					}
				});
				return BBSBannedStatus;
			}

			function checkBoardLevel() {
				// 글쓰기 레벨 체크
				var boardLevel = void 0;
				var _categoryId = $('.selectedCategory').attr('data-value') || $('[name="board-category"] option:selected').val() || $(".scroll-category .category-items.is-active").data('value') || window._boardConfig.categoryId || ''; // 5ec50d7c82915c0001ace1f1
				console.log('Utils checkBoardLevel , check is bbs writable _categoryId : ', _categoryId, window._boardConfig);

				$.ajax({
					type: 'GET',
					// url: window._path+'board/writer/'+_board+'/character-level',
					url: window._communityApiPath + 'board/writer/is-bbs-writable?boardAlias=' + _board + '&categoryId=' + _categoryId,
					async: false,
					// dataType: 'json',
					contentType: 'application/json',
					xhrFields: { withCredentials: true },
					success: function success() {
						boardLevel = true;
						// console.log('Utils.js > HookWriteBefore checkBoardLevel success data/boardLevel : ', data, boardLevel );
						// return boardLevel = true;
					},
					error: function error(data) {
						boardLevel = false;
						// console.log('Utils.js > HookWriteBefore checkBoardLevel error data/boardLevel : ', data, boardLevel);
						alert(data.responseJSON.result.message); // 얼럿이 두번 떠서 이거 제거함
						// return boardLevel = false;
					}
				});
				return boardLevel;
			}

			if (!userData.isLogin) {
				GNBLogin();
				return false; //false 리턴 시 write 페이지로 이동하지 않음
			} else {

				var _isBbsBanned2 = isBBSBanned();
				var _isBbsWritable2 = checkBoardLevel();

				var caseNum = '';
				if (userData.accountState.length > 0) caseNum = userData.accountState[userData.accountState.length - 1].case;

				if (!_isBbsWritable2) {
					return false;
				}
				if (_isBbsBanned2 || caseNum == '7' || caseNum == '8' || caseNum == '9') {
					alert('제재된 계정입니다. 자세한 사항은 고객센터로 문의해 주세요.');
					return false;
				} else if (caseNum == '2') {
					alert('본인확인이 필요합니다.');
					return false;
				} else if (caseNum == '3' || userData.gameAccount.name == null || userData.gameAccount.name == '') {
					alert('서비스 이용을 위해 대표 캐릭터를 선택해 주세요.');
					return false;
				} else {
					return true; //true 리턴 시 write 페이지로 이동
				}
			}

			console.log('_isBbsBanned , _isBbsWritable : ', _isBbsBanned, _isBbsWritable);
		}
	}, {
		key: 'ServerMasterBoard',
		get: function get() {
			var isServerMasterBoard = void 0;
			var locationParams = Object(__WEBPACK_IMPORTED_MODULE_0__utils_util__["g" /* getUriParams */])(document.location.href) || {};
			isServerMasterBoard = locationParams.metaTags && locationParams.metaTags == 'servermaster' ? true : false;
			return isServerMasterBoard;
		}
	}, {
		key: 'getServerAlias',
		get: function get() {
			var ServerAlias = void 0;
			ServerAlias = window.userData.gameAccount.serverId || 1;
			return ServerAlias;
		}
	}]);

	return Utils;
}();

/* harmony default export */ __webpack_exports__["a"] = (Utils);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_service__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_util__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model_msg_alert__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__model_model__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vendor_nccommunity_DropDownLayer__ = __webpack_require__(5);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





 // http://git.korea.ncsoft.corp/projects/FRONTEND_DEVELOP/repos/uikit-nccommunity/browse/_src/js/DropDownLayer.js

var ServerWrite = function () {
  function ServerWrite(options) {
    _classCallCheck(this, ServerWrite);

    var _ = this;

    if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["k" /* isNotDefined */])(options)) throw new Error('ServerWrite constructor require options object');

    // _.GAP_SERVER_ID = 47; // opdev: 50, rc: 47

    _.option = $.extend({
      wrap: null,
      apiDomain: '' || __WEBPACK_IMPORTED_MODULE_3__model_model__["b" /* API_DOMAIN_DEFAULT */],
      hostApiDomain: '' || __WEBPACK_IMPORTED_MODULE_3__model_model__["b" /* API_DOMAIN_DEFAULT */],
      ncCommunityWrite: null,
      isIngame: false,
      serverAlias: 1,
      serverName: null,
      global: window
    }, options);

    _.global = _.option.global;

    _.wrap = _.option.wrap;

    _.serverId = Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["n" /* parseInt10 */])(_.option.serverAlias);
    _.serverName = _.option.serverName;

    _.serverMasterDropdown = null;

    _.ncCommunityWrite = _.option.ncCommunityWrite;

    _.msg = {
      NO_SERVER_ID: '글을 등록할 서버를 찾을 수 없습니다.',
      NOT_MASTER_IN_SERVER: '이 캐릭터는 해당 서버의 서버지기가 아닙니다.'
    };

    _.isEdit = false;
  }

  _createClass(ServerWrite, [{
    key: 'init',
    value: function init() {
      var _ = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["k" /* isNotDefined */])(_.option.ncCommunityWrite)) throw new Error('ServerWrite constructor require options has ncCommunityWrite parameter');

      // after initialize ncCommunityWrite, call setInstance method
      _.option.ncCommunityWrite.onLoaded.add(_.setInstance, _);

      return _;
    }
  }, {
    key: 'setInstance',
    value: function setInstance(writeData) {
      // 1. write new : undefined
      // 2. rewrite(edit) : { title, contents, serverMaster }

      var _ = this;

      // there is item which server master have written
      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["o" /* truthy */])(_.option.isIngame)) {
        // ingame - no process

      } else {
        // pc, mobile

        // api - http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=97027727
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["a" /* getDatasWithOption */])([{
          type: 'GET',
          url: _.option.hostApiDomain + 'api/servermaster/' + _.serverId + '/isServerMaster',
          dataType: 'json',
          xhrFields: { withCredentials: true }

        }], function (data) {
          console.log('isServerMasterSuccess :', data);

          // if user character is server master
          if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(data) && data.result === true) {
            // append server master dropdown
            _.setServerMasterDropdown();

            if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["k" /* isNotDefined */])(writeData)) {
              console.log('write new article : ', writeData);

              _.serverMasterDropdown.setTextValue('일반');
            } else {
              console.log('rewrite article (edit) :', writeData);
              _.isEdit = true;

              if (writeData.serverMaster) {
                // 202005
                // server master have written
                _.serverMasterDropdown.setTextValue('서버지기');
              } else {
                // normal
                _.serverMasterDropdown.setTextValue('일반');
              }
            }
          }
        }, function (data) {
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["b" /* handleApiError */])(data);
        });
      }
    }
  }, {
    key: 'setServerMasterDropdown',
    value: function setServerMasterDropdown() {
      var _ = this,
          dropdownWrap = $('<div class="board-write__category"></div>');

      $('.board-write-title').before(dropdownWrap);

      _.serverMasterDropdown = new __WEBPACK_IMPORTED_MODULE_4__vendor_nccommunity_DropDownLayer__["a" /* default */](dropdownWrap, [{ 'key': 'normal', value: '일반' }, { 'key': 'servermaster', value: '서버지기' }], 'boardServerMaster');
    }
  }, {
    key: 'setServerDropdown',
    value: function setServerDropdown() {
      var _ = this;
      var userData = global.userData || null;

      var selectedOption = null,
          dropdownCategoryId = null,
          dropdownServerName = null;

      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["a" /* anyOf */])($('body').hasClass('mobile'), $('body').hasClass('tablet'))) {
        // mobile device
        selectedOption = $('#boardWriteForm .ui-dropdown-elements select option:selected');
        dropdownCategoryId = selectedOption.val();
        dropdownServerName = selectedOption.text();
      } else {
        // pc device
        var dropdownOptions = $('#boardWriteForm .ui-dropdown-community .option li');
        dropdownServerName = $('#boardWriteForm .board-write-category .ui-dropdown-community .select > span').text();

        for (var i = 0, max = dropdownOptions.length; i < max; i++) {
          if ($(dropdownOptions.get(i)).attr('data-textValue') === dropdownServerName) {
            selectedOption = $(dropdownOptions.get(i));
            break;
          }
        }

        console.log('selectedOption : ', selectedOption, selectedOption.attr('data-textValue'), selectedOption.attr('data-value'));

        dropdownCategoryId = selectedOption.attr('data-value');
        dropdownServerName = selectedOption.attr('data-textValue');
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["k" /* isNotDefined */])(userData) || Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["c" /* falsy */])(userData.isLogin)) return;
      if (userData.gameAccount.serverName != dropdownServerName) {
        _.global.alert(_.msg.NO_SERVER_ID); // '글을 등록할 서버를 찾을 수 없습니다.'
        return false;
      }

      return true;
    }
  }, {
    key: 'submitWriteData',
    value: function submitWriteData(data) {
      var _ = this;

      var sendData = null;

      if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["o" /* truthy */])(_.option.isIngame)) {
        // ingame
        sendData = data;

        if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(_.option.ncCommunityWrite)) _.option.ncCommunityWrite.onSubmit(sendData);
      } else {
        // pc, mobile
        sendData = $.extend(true, {
          servermaster: Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(_.serverMasterDropdown) && _.serverMasterDropdown.getValue() === 'servermaster' ? true : false
        }, data);

        console.log('sendData :', sendData);

        // check character is server's server master.
        if (!_.isEdit && Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(_.serverMasterDropdown) && _.serverMasterDropdown.getValue() === 'servermaster') {
          // 서버지기 dropdown 이 '서버지기' 로 선택되어 있을 때

          // if(! _.setServerDropdown()) return;


          /*
              let selectedOption = null,
                dropdownCategoryId = null,
          dropdownServerName = null;
                if (anyOf($('body').hasClass('mobile'), $('body').hasClass('tablet'))) {
                // mobile device
                selectedOption = $('#boardWriteForm .ui-dropdown-elements select option:selected');
                dropdownCategoryId = selectedOption.val();
          dropdownServerName = selectedOption.text()
                } else {
                // pc device
          const dropdownOptions = $('#boardWriteForm .ui-dropdown-community .option li');
          dropdownServerName = $('#boardWriteForm .board-write-category .ui-dropdown-community .select > span').text();
                  for (let i = 0, max = dropdownOptions.length; i < max; i++) {
                  if ($(dropdownOptions.get(i)).attr('data-textValue') === dropdownServerName) {
                    selectedOption = $(dropdownOptions.get(i));
                    break;
                  }
                }
                  console.log('selectedOption : ', selectedOption, selectedOption.attr('data-textValue'), selectedOption.attr('data-value'));
                  dropdownCategoryId = selectedOption.attr('data-value');
          dropdownServerName= selectedOption.attr('data-textValue');
              }
          const userData = global.userData || null;
          if (isNotDefined(userData) || falsy(userData.isLogin)) return;
          if(userData.gameAccount.serverName != dropdownServerName){
          _.global.alert(_.msg.NO_SERVER_ID); // '글을 등록할 서버를 찾을 수 없습니다.'
          return;
          }
          */

          // api - http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=97027727
          Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["a" /* getDatasWithOption */])([{
            type: 'GET',
            url: _.option.hostApiDomain + 'api/servermaster/' + _.serverId + '/isServerMaster',
            dataType: 'json',
            xhrFields: { withCredentials: true }

          }], function (data) {
            console.log('isServerMasterSuccess :', data);

            // if user character is server master
            if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(data) && data.result === true) {
              console.log('user character is servermaster in this server');

              if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(_.option.ncCommunityWrite)) _.option.ncCommunityWrite.onSubmit(sendData);
              console.log(' 서버마스터일경우 : ', sendData);
            } else {
              console.log('user character is not !!! servermaster in this server');

              _.global.alert(_.msg.NOT_MASTER_IN_SERVER); // '이 캐릭터는 해당 서버의 서버지기가 아닙니다.'

              if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["i" /* isFunction */])(_.ncCommunityWrite.enableWriteButton)) _.ncCommunityWrite.enableWriteButton();
            }
          }, function (data) {
            Object(__WEBPACK_IMPORTED_MODULE_0__utils_service__["b" /* handleApiError */])(data);
          });
        } else {
          // there is not server master dropdown, or user is not server master.
          console.log('there is not server master dropdown, or user is not server master');

          if (Object(__WEBPACK_IMPORTED_MODULE_1__utils_util__["h" /* isDefined */])(_.option.ncCommunityWrite)) _.option.ncCommunityWrite.onSubmit(sendData);
        }
      }
    } // submitWriteData()

  }]);

  return ServerWrite;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (ServerWrite);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// board/servermaster.js